module.exports = __webpack_public_path__ + "img/baby.66c10f6b.jpg";